import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream-deep" data-id="element-228" data-mp="3krp5n656qzqv">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-229" data-mp="3fzntdk80p90u">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-230" data-mp="3fxkusbssu7ki">
          <h2 className="max-w-2xl font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-231" data-mp="3b0axk9z64rm4">
            Personas que ya ordenaron sus cuentas
          </h2>
          <p className="flex items-center gap-2 text-sm font-semibold text-ink-muted" aria-label="Calificación promedio 4.9 de 5" data-id="element-232" data-mp="31yuuyoelhtsg">
            <span className="flex" aria-hidden="true" data-id="element-233" data-mp="2x11pxyp135tr">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" data-id="element-234" data-mp="v9g8xjyrhwnk" data-mpi={index} />)}
            </span>
            4.9 / 5 promedio
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-235" data-mp="qavb1r6zfp2a">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-xl bg-white p-6" data-id="element-236" data-mp="h4dfoti1e27v">
              <span className="flex" aria-hidden="true" data-id="element-237" data-mp="m6m5jgzm4o5r">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-238" data-mp="7a4uyrz8zdk9" data-mpi={index} />)}
              </span>
              <blockquote className="mt-4 text-base leading-relaxed text-ink" data-id="element-239" data-mp="zwfvy3qrnghl">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-240" data-mp="14u7nuxrev2ls">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-mist font-display text-xs font-bold text-forest" data-id="element-241" data-mp="q765esbkm5vl">
                  {testimonial.initials}
                </span>
                <p className="text-sm" data-id="element-242" data-mp="1iv1xtku3xbmk">
                  <span className="font-semibold text-ink" data-id="element-243" data-mp="1itzafmvztrbe">
                    {testimonial.name}
                  </span>
                  <span className="block text-ink-muted" data-id="element-244" data-mp="1xi0o3ch89zzp">
                    {testimonial.location}
                  </span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}